import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SearchTypeahead } from '@bambi/component-library/src/components/SearchTypeahead/SearchTypeahead';

import { MIN_TRIP_SEARCH_TERM_LENGTH } from '../../constants';
import { romAllRequestsSlice } from './rom-all-requests.slice';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import DateRangeBadge from 'src/common/date/DateRangeBadge';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';

export function RomAllRequestsRouteActions() {
  const dispatch = useAppDispatch();
  const { searchTerm, selectedPayers, selectedStatuses, selectedDateRange } =
    useAppSelector((state) => state.romAllRequests);

  const { inputValue, handleInputChange } = useDebouncedSearch(
    romAllRequestsSlice.actions.setSearchTerm,
    searchTerm
  );

  const handleClearClick = () => {
    dispatch(romAllRequestsSlice.actions.clearFilters());
  };

  return (
    <div className="flex gap-4">
      {selectedPayers.length > 0 ||
      selectedStatuses.length > 0 ||
      selectedDateRange?.from ? (
        <Button
          dataTestId="clear-filters-btn"
          onClick={handleClearClick}
          variant="anchor"
        >
          clear filters
        </Button>
      ) : null}
      {selectedDateRange?.from && selectedDateRange.to && (
        <div>
          <DateRangeBadge
            from={selectedDateRange.from}
            to={selectedDateRange.to}
            onClear={() => {
              dispatch(
                romAllRequestsSlice.actions.setSelectedDateRange(undefined)
              );
            }}
          />
        </div>
      )}
      <SearchTypeahead
        dataTestId="rom-all-requests-search-input"
        onChange={handleInputChange}
        placeholder="Search all requests"
        value={inputValue}
        minLength={MIN_TRIP_SEARCH_TERM_LENGTH}
      />
    </div>
  );
}
